import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TimePickerComponent,
      multi: true
    }
  ]
})
export class TimePickerComponent implements OnInit, ControlValueAccessor {

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  model: string;
  options: string[];

  @Input()
  timeFrom: number;

  @Input()
  timeTo: number;

  @Input()
  sumeTime:number;

  onChange!: (value: any) =>  void;

  constructor() { 
    this.model = '';

    this.options = [];
    this.placeholder = '';
    this.required = false;
    this.submitted = false;

    this.timeFrom = 0;
    this.timeTo = 24;
    this.sumeTime = 5;
  }
  writeValue(obj: any): void {
    this.model = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit(): void {
    this.initializeOptions();
  }

  initializeOptions() {
    for (let i = this.timeFrom; i <= this.timeTo; i++) {
      this.options.push(`${this.formatTime(i)}:00`);
      if(i < this.timeTo){
        this.options.push(`${this.formatTime(i)}:30`);
      }
    }
  }

  formatTime(time: number): string {
    if (time < 10) {
      return `0${time}`;
    } else {
      return time.toString();
    }
  }

  validate(): boolean {
    if (!this.submitted) {
      return true;
    }
    if (this.sumeTime < 4) {
      return false;
    }
    return true;
  }
}